<template>
  <div>
    <Nuevo
      :dialog="dialog"
      :Item="itemSelected"
      @dialog="dialog = $event"
      :Roles="Roles"
      @cerrarModal="cerrarModal"
      v-if="verNuevo"
    />
    <Eliminar
      :dialog="dialogeliminar"
      :Descripcion="descripcioneliminar"
      @dialog="dialogeliminar = $event"
      @cerrarModalEliminar="cerrarModalEliminar"
    />
    <MensajeTransicion
      color="success"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />

    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header Principal estilo Inspección / Cliente -->
      <v-toolbar height="58" color="secondary" dark flat class="px-3">
        <div class="d-flex align-center">
          <v-icon left>mdi-account-group-outline</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Titulo || "Miembros del Cliente" }}
          </span>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-counter</v-icon>
            {{ Items ? Items.length : 0 }} Miembros
          </v-chip>
        </div>

        <v-spacer></v-spacer>

        <!-- Botón de Ayuda -->
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-1 btn-circle-tooltip"
              icon
              dark
              target="_blank"
              :href="global.helpdesk_url + 'miembros_cliente'"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="25" color="amber lighten-2">mdi-help-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>¿Necesitas ayuda?</span>
        </v-tooltip>
      </v-toolbar>

      <!-- Sección de Filtro y Acciones -->
      <div class="pa-4 pb-2">
        <v-row dense class="align-center mb-1">
          <!-- Búsqueda Rápida -->
          <v-col cols="12" md="6" lg="6">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              label="Búsqueda rápida"
              placeholder="Buscar por nombre, email, rol..."
              class="rounded-lg"
            ></v-text-field>
          </v-col>

          <!-- Botones de Acción -->
          <v-col cols="12" md="6" lg="6" class="d-flex align-center justify-end flex-wrap gap-2">
            <!-- Descargar Excel -->
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg mr-2"
              @click="DescargarExcel()"
            >
              <v-icon left size="18">mdi-file-excel</v-icon>
              Descargar Tabla
            </v-btn>

            <!-- Botón Nuevo -->
            <v-btn
              v-if="global._autorizacion_usuario(Permisos, $route.meta.id, ['2'])"
              color="primary"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg mr-2"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nuevo Miembro
            </v-btn>

            <!-- Botón Regresar -->
            <v-btn
              outlined
              color="grey darken-1"
              height="38"
              class="px-4 font-weight-medium text-none rounded-lg"
              @click="regresar()"
            >
              <v-icon left small>mdi-arrow-left</v-icon>
              Regresar
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- Tabla Principal -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="Cabecera"
          :loading="loading"
          :items="Items"
          :items-per-page="50"
          :search="search"
          class="modern-table elevation-0"
          loading-text="Cargando miembros... Por favor, espere"
          no-data-text="No hay miembros registrados para este cliente"
          :footer-props="{
            'items-per-page-text': 'Resultados por página:',
            'items-per-page-options': [10, 25, 50, 100],
            'page-text': '{0}-{1} de {2}'
          }"
        >
          <!-- Columna Nombre -->
          <template v-slot:[`item.name`]="{ item }">
            <div class="d-flex align-center">
              <v-avatar size="30" color="primary" class="mr-2 white--text font-weight-bold text-caption">
                {{ item.name ? item.name.charAt(0).toUpperCase() : 'U' }}
              </v-avatar>
              <span class="font-weight-medium text-body-2 text--primary">{{ item.name }}</span>
            </div>
          </template>

          <!-- Columna Email -->
          <template v-slot:[`item.email`]="{ item }">
            <div class="d-flex align-center">
              <v-icon small color="grey darken-1" class="mr-1">mdi-email-outline</v-icon>
              <span class="text-body-2">{{ item.email }}</span>
            </div>
          </template>

          <!-- Columna Rol -->
          <template v-slot:[`item.role`]="{ item }">
            <v-chip
              small
              color="indigo lighten-5"
              text-color="indigo darken-3"
              class="font-weight-bold elevation-1 px-3"
            >
              <v-icon left x-small color="indigo darken-2">mdi-shield-outline</v-icon>
              {{ item.role }}
            </v-chip>
          </template>

          <!-- Columna Acciones -->
          <template v-slot:[`item.accion`]="{ item }">
            <div class="d-flex align-center justify-center gap-1">
              <!-- Editar -->
              <v-tooltip bottom v-if="global._autorizacion_usuario(Permisos, $route.meta.id, ['3'])">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="26"
                    width="26"
                    color="blue lighten-1"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="editarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar Miembro</span>
              </v-tooltip>

              <!-- Eliminar -->
              <v-tooltip bottom v-if="global._autorizacion_usuario(Permisos, $route.meta.id, ['4'])">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="26"
                    width="26"
                    color="red lighten-1"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="eliminarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Miembro</span>
              </v-tooltip>

              <!-- Enviar Credenciales -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="26"
                    width="26"
                    color="teal lighten-1"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="enviarCredenciales(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-email</v-icon>
                  </v-btn>
                </template>
                <span>Enviar credenciales de acceso</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Nuevo from '../miembros/nuevo.vue';
import Eliminar from '../ModalEliminar.vue';
import router from '@/router';
import exportFromJSON from 'export-from-json';
import MensajeTransicion from '../Alerta.vue';
import global from '@/global';

export default {
  props: ['Titulo', 'Cabecera', 'Items', 'Excel', 'Crear', 'Roles', 'Cliente'],
  components: {
    Nuevo,
    Eliminar,
    MensajeTransicion
  },
  inject: ['llamarindexMembers'],
  data() {
    return {
      search: '',
      mensaje: '',
      dialog: false,
      loading: false,
      itemSelected: {},
      verNuevo: false,
      verAlerta: false,
      dialogeliminar: false,
      descripcioneliminar: '',
      global: global
    };
  },
  computed: {
    ...mapState('navigation', ['Permisos'])
  },
  methods: {
    ...mapActions('usercliente', ['deleteUserCliente', 'sendCredentialsUserCliente']),

    regresar() {
      router.go(-1);
    },

    nuevoItem() {
      let id_cliente = null;
      if (this.Cliente == undefined) {
        id_cliente = location.pathname.substr(1).split('/')[1];
      } else {
        id_cliente = this.Cliente;
      }

      this.itemSelected = {
        id: null,
        nombres: null,
        apellidos: null,
        email: null,
        role_id: null,
        id_cliente: id_cliente
      };
      this.dialog = true;
      this.verNuevo = true;
    },

    editarItem(item) {
      this.itemSelected = { ...item };
      this.itemSelected.id = this.itemSelected.id_user;
      this.dialog = true;
      this.verNuevo = true;
    },

    eliminarItem(item) {
      this.descripcioneliminar = '¿Desea eliminar el usuario "' + item.name + '"?';
      this.itemSelected = { ...item };
      this.itemSelected.id = this.itemSelected.id_user;
      this.dialogeliminar = true;
    },

    async enviarCredenciales(item) {
      this.itemSelected = { ...item };
      this.itemSelected.id = this.itemSelected.id_user;
      this.loading = true;
      await this.sendCredentialsUserCliente(this.itemSelected.id);
      this.loading = false;
      this.verAlerta = true;
      this.mensaje = 'Credenciales enviadas con éxito al correo ' + this.itemSelected.email;
      setTimeout(() => [(this.verAlerta = false)], 4000);
    },

    cerrarModal(valor) {
      if (valor == true) {
        router.go();
      }
      this.verNuevo = false;
    },

    async cerrarModalEliminar() {
      this.dialogeliminar = false;
      this.loading = true;
      await this.deleteUserCliente(this.itemSelected.id);
      this.llamarindexMembers(this.$route.params.id);
      this.loading = false;
      this.verAlerta = true;
      this.mensaje = 'El usuario ha sido eliminado exitosamente';
      setTimeout(() => [(this.verAlerta = false)], 4000);
    },

    DescargarExcel() {
      const data = this.Items;
      const nombreArchivo = 'miembros_cliente_' + new Date().toISOString().slice(0, 10);
      const exportType = exportFromJSON.types.xls;
      exportFromJSON({ data, nombreArchivo, exportType });
    }
  }
};
</script>

<style scoped>
.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-size: 0.84rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px;
  white-space: nowrap;
  height: 44px !important;
  border-bottom: none !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th .v-icon {
  color: #ffffff !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th:hover {
  background-color: #333333 !important;
}

.modern-table ::v-deep thead tr.v-data-table__progress th {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 10px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out !important;
}

.action-btn:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.gap-1 {
  gap: 4px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
